import { CHANGE_PASSWORD } from "../actions/types";

export default (response = null, action) => {
  if (action.type === CHANGE_PASSWORD) {
    return action.payload;
  }
  return response;
};
